module.exports = __webpack_public_path__ + "media/images/background-649b37966451c5518805819b111c7824.jpg";